import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
    import { getTHGUser, saveTHGUser } from '@/api/thg/users';
    import { useRoute } from 'vue-router/composables';
    import { THGUser } from '@/interfaces/thg/THGUser';
    import THGUserForm from '@/components/thg/user/THGUserForm.vue';
    import emitter from '@/utils/mitt';
    import { ToastProgrammatic as Toast } from 'buefy';
    import { createTHGUserUpdateData, generateDisplayName } from '@/utils/thg';
    import { alertError } from '@/utils/dialogs';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'THGUser',
  setup(__props) {

    const route = useRoute();

    const user = ref<THGUser | null>(null);

    async function saveUser() {
        if (!user.value) {
            throw new Error('user is undefined');
        }

        emitter.emit('showLoader');

        // create the update data
        const updateData = createTHGUserUpdateData(user.value);

        // do the actual update
        const response = await saveTHGUser(user.value.id, updateData);

        if (response.status !== 200) {
            alertError('Fehler', 'Fehler beim Speichern des Users.');
        } else {
            Toast.open({ type: 'is-success', message: 'User wurde erfolgreich gespeichert.' });
        }

        emitter.emit('hideLoader');
    }

    onMounted(async () => {
        const response = await getTHGUser(route.params.userId);
        const user_obj = response.parsedBody;

        if (!user_obj) {
            throw new Error('Error while fetching user.');
        }

        user.value = user_obj;
    });

return { __sfc: true,route, user, saveUser, THGUserForm, generateDisplayName }
}

})